import { useContext } from 'react';

import { OnboardingContext, type OnboardingContextValue } from './onboardingContextDef';

/** What this tenant still owes, and how to re-read it. */
export function useOnboarding(): OnboardingContextValue {
  return useContext(OnboardingContext);
}
